import { Box, Typography } from '@mui/material';
import React from 'react';

interface HeaderLogoProps {
  shortName?: string;
}

export default function HeaderLogo({ shortName }: HeaderLogoProps) {
  return (
    <Box
      sx={{
        mt: { xs: 12, sm: 10 },
        mb: { xs: 4, sm: 2 },
        display: 'flex',
        justifyContent: { xs: 'center', sm: 'flex-start' },
        alignItems: 'center'
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: { xs: '1.9rem', sm: '2.45rem', md: '3rem' },
          letterSpacing: { xs: -2, sm: -2.5, md: -3 },
          fontFamily: 'Comfortaa',
          fontWeight: 700
        }}
      >
        {shortName ? 'space' : 'backspace'}
      </Typography>
      {shortName && (
        <Typography
          component="span"
          sx={(theme) => ({
            mt: { xs: 0, sm: 0.25, md: 0.5 },
            ml: { xs: 0.75, sm: 1, md: 1.25 },
            px: { xs: 0.75, sm: 1, md: 1.25 },
            py: { xs: 0.25, sm: 0.375, md: 0.5 },
            background: theme.palette.gradient.main,
            color: 'background.paper',
            borderRadius: { xs: '8px', sm: '12px', md: '16px' },
            fontFamily: 'Comfortaa',
            fontSize: { xs: '0.95rem', sm: '1.23rem', md: '1.5rem' },
            fontWeight: 700
          })}
        >
          {shortName}
        </Typography>
      )}
    </Box>
  );
}
